import { AvatarProps } from '@radix-ui/react-avatar'
import * as React from 'react'

import { useTenantMediaDefaults } from '@/hooks/use-tenant-media-defaults'

import { Icons } from '@/components/icons'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'

import { UserProfile } from '@/types/user.type'

interface UserAvatarProps extends AvatarProps {
  user: UserProfile
}

export function UserAvatar({ user, ...props }: UserAvatarProps) {
  const { resolveAvatarUrl } = useTenantMediaDefaults()
  const avatarSrc = resolveAvatarUrl(user.avatar)

  return (
    <Avatar {...props}>
      {avatarSrc ? (
        <AvatarImage
          alt={user?.firstName + ' ' + user?.lastName}
          src={avatarSrc}
          referrerPolicy="no-referrer"
          loading="lazy"
        />
      ) : null}
      <AvatarFallback>
        <span className="sr-only">{user?.firstName + ' ' + user?.lastName}</span>
        <Icons.user className="size-4" />
      </AvatarFallback>
    </Avatar>
  )
}
